"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignTargetContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _AlignTargetProvider = require("redhotmagma-visualization/AlignTargetProvider");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var style = {
  root: {
    flex: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    width: 'inherit',
    height: 'inherit',
    // the pointer events should be passed through to the visualization component
    pointerEvents: 'inherit' // important: don't remove this
  }
};

var AlignTargetContainer = exports.AlignTargetContainer = (0, _styles.withStyles)(style, {
  name: 'AlignTargetContainer'
})((0, _AlignTargetProvider.withAlignTarget)(function (_ref) {
  var alignTarget = _ref.alignTarget,
    children = _ref.children,
    classes = _ref.classes,
    className = _ref.className;
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (ref.current) {
      alignTarget.add(ref.current);
    }
    return function () {
      return alignTarget.remove(ref.current);
    };
  }, [alignTarget]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: (0, _clsx["default"])(classes.root, className)
  }, children);
}));